(() => {
  const widgetSelector = "etrusted-widget";
  const cardRatingSelector = ".product-card__review-row > etrusted-widget";
  const scriptSelector = 'script[src*="integrations.etrusted.com/applications/widget.js"]';
  const scriptUrl = "https://integrations.etrusted.com/applications/widget.js/v2";
  const observedCardRatings = new WeakSet();

  const updateCardRatingVisibility = (widget) => {
    const ratingRow = widget.closest(".product-card__review-row");
    if (!ratingRow) return;

    const bounds = widget.getBoundingClientRect();
    const hasVisibleRating = bounds.width > 4 && bounds.height > 4;

    ratingRow.toggleAttribute("data-rating-visible", hasVisibleRating);
    ratingRow.setAttribute("aria-hidden", hasVisibleRating ? "false" : "true");
  };

  const cardRatingResizeObserver = new ResizeObserver((entries) => {
    entries.forEach((entry) => updateCardRatingVisibility(entry.target));
  });

  const loadWidgetRuntime = () => {
    if (customElements.get("etrusted-widget") || document.querySelector(scriptSelector)) return;

    const script = document.createElement("script");
    script.src = scriptUrl;
    script.async = true;
    document.head.appendChild(script);
  };

  const observeCardRating = (widget) => {
    if (!widget.matches(cardRatingSelector) || observedCardRatings.has(widget)) return;

    observedCardRatings.add(widget);
    cardRatingResizeObserver.observe(widget);
    requestAnimationFrame(() => updateCardRatingVisibility(widget));
  };

  const initializeWidgets = (root) => {
    const widgets = [];

    if (root.matches?.(widgetSelector)) widgets.push(root);
    root.querySelectorAll?.(widgetSelector).forEach((widget) => widgets.push(widget));

    if (widgets.length > 0) window.BaechleinPrivacy?.whenAllowed("marketing", loadWidgetRuntime);
    widgets.forEach(observeCardRating);
  };

  initializeWidgets(document);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) initializeWidgets(node);
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
